export const Link = {
  baseStyle: {
    color: 'brand.primary',
    _hover: {
      color: 'brand.primary',
      opacity: 0.8,
      textDecoration: 'none',
    },
  },
  variants: {
    navLink: {
      color: 'black',
      _hover: {
        color: 'brand.primary',
        textDecoration: 'none',
      },
    },
    menuLink: {
      color: 'black',
      _hover: {
        color: 'brand.link',
        textDecoration: 'none',
      },
    },
    adminPrimary: {
      color: 'brand.link',
      _hover: {
        color: 'brand.link',
      },
    },
    neutral: {
      color: 'neutral.800',
      fontWeight: 600,
      textDecoration: 'underline',
      _hover: {
        textDecoration: 'underline',
        color: 'neutral.800',
        opacity: 1,
      },
    },
    userMenuNotification: {
      fontSize: '14px',
      fontWeight: 600,
      textDecoration: 'underline',
      color: 'brand.link',
      _hover: {
        color: 'brand.link',
        textDecoration: 'underline',
      },
    },
  },
};
